import * as tslib_1 from "tslib";
import { BaseService } from '../base.service';
import { OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
var WalletBankAccountService = /** @class */ (function (_super) {
    tslib_1.__extends(WalletBankAccountService, _super);
    function WalletBankAccountService(http) {
        var _this = _super.call(this, 'wallet-bank-account', http) || this;
        _this.http = http;
        return _this;
    }
    WalletBankAccountService.prototype.ngOnInit = function () {
    };
    return WalletBankAccountService;
}(BaseService));
export { WalletBankAccountService };
